module.exports = {"610403001":"杨陵街道","610403002":"李台街道","610403003":"大寨街道","610403100":"五泉镇","610403102":"揉谷镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610403.json
// module id = 2944
// module chunks = 0